export default __webpack_public_path__ + "static/media/epicenter_logo.42c2737c.png";